import {License, LicenseRegexCountry} from "../../core/models/vehicle";
import {flatten} from "lodash";
import {Company} from "../../core/models/company";
import {LicenseValidators} from "./validators.utils";
import {hasElements} from "./generics.utils";
import isEmpty from "lodash/isEmpty";

export const getValidatedLicense = (company: Company, license: string, licenseCountryCode?: string) => {
  let value: License | undefined;
  const regexs = getLicensePlateRegex(company);
  const licenseCountry = licenseCountryCode ?? LicenseValidators.isLicensePlate(license, regexs)?.countryCode;
  if (licenseCountry) {
    value = new License(license, licenseCountry);
    const fLicensePlate = getLicenseWithSeparator(value, regexs);
    if (fLicensePlate && LicenseValidators.isLicensePlate(fLicensePlate, regexs)) {
      value.license = fLicensePlate;
    }
  }
  return value;
}

export const getLicensePlateRegex = (company: Company): LicenseRegexCountry[] => {
  let regexs: LicenseRegexCountry[] = [];
  if (company) {
    regexs = flatten(company.acceptedLicenses.map(l => l.regexList.map(r => new LicenseRegexCountry(l.countryCode, new RegExp(r.regex), r.separators))))
  }
  return regexs;
}

export const getLicenseWithSeparator = (license: License|undefined, acceptedLicenses: LicenseRegexCountry[])=> {
  let fLicense = license?.license;
  if (license?.countryISO) {
    const matchedRegex = acceptedLicenses.find(al => al.countryCode === license.countryISO && al.regex.test(license.license));
    if (matchedRegex) {
      if (hasElements(matchedRegex.separators)) {
        fLicense = formatLicensePlate(matchedRegex, matchedRegex.separators!, license.license);
      } else {
        let separators = matchedRegex.regex.toString().split(/\(.*?\)/).slice(1);
        separators.pop();
        separators = separators.map((s) => s.includes('\s') ? ' ' : s.replace('{0,1}', ''));

        fLicense = formatLicensePlate(matchedRegex, separators, license.license);
      }
    }
  }
  return fLicense?.toUpperCase();
}

const formatLicensePlate = (regex: LicenseRegexCountry, separators: string[], fLicense: string) => {
  const result = regex.regex.exec(fLicense)?.filter(v => !isEmpty(v)); // Get all groups for the license from the executed regex.
  if (result) {
    fLicense = '';
    if (result.length <= 2) { // If result length is under two, there is no group, so no separator to apply.
      fLicense = result[0];
    } else { // Ignore first value as it is initial text and then concatenate regex group and separators.
      result.slice(1).forEach((group, i) => {
        fLicense += group
        if (i < separators.length) {
          fLicense += separators[i]
        }
      })
    }
  }

  return fLicense;
}
